export default class SizeChart extends HTMLElement {
    constructor() {
        super();
        
        debug('SizeChart');
    }
    
    connectedCallback() {
        this.setupEventListeners();
        this.convertUnits();
    }
    
    disconnectedCallback() {}

    setupEventListeners() {
        this.querySelectorAll('.size-chart__toggle button').forEach((element) => {
            element.addEventListener('click', (event) => {
                event.preventDefault();
                debug('SizeChart units click');

                this.resetUnits();
                this.showUnits(element.dataset.unit);
                element.classList.add('active');
            });
        });   
    }
    
    showUnits(selector) {
        debug('SizeChart showUnits', selector);
        this.querySelectorAll('.size-chart__table span.' + selector).forEach((element) => {
            element.classList.remove('hidden');
        });
    }

    resetUnits() {
        this.querySelectorAll('.size-chart__toggle button').forEach((element) => {
            element.classList.remove('active');
        });

        this.querySelectorAll('.size-chart__table td span').forEach((element) => {
            element.classList.add('hidden');
        });
    }    

    convertUnits() {
        debug('SizeChart convertUnits');
        let table = this.querySelector('.size-chart__table');

        if (table && ! table.classList.contains('converted')) {
            debug('SizeChart convertUnits converting');
            table.querySelectorAll('td').forEach((element) => {
                if ( ! isNaN(element.innerText)) {
                    let value = parseFloat(element.innerText);
                    let centimeters = value * 2.54;
                    let centimetersRounded = (centimeters * 10) / 10;
                    //let inches = centimeters * 0.393701;

                    let converted = `<span class="in">${value}</span><span class="cm hidden">${centimetersRounded.toFixed(1)}</span>`;
                    element.innerHTML = converted;
                }
            });

            table.classList.add('converted');
        }
    }
}